import { Alert } from "@mui/material"

/**
 * Aviso de abertura da janela de ingresso — mesmo Alert (warning) na lista e nos detalhes.
 */
export default function GestaoVagaAlertaJanelaIngresso({
	dataInicioIngresso = "",
	dataInicioIngressoFormatada = "",
	className = "",
}) {
	const label =
		String(dataInicioIngressoFormatada || dataInicioIngresso || "").trim() || "—"

	return (
		<Alert
			severity="warning"
			className={`gv-alert-linha-toda gv-alerta-janela-ingresso ${className}`.trim()}
		>
			Você poderá ingressar a partir de <strong>{label}</strong>.
		</Alert>
	)
}
